import React from 'react';
import { Box, Typography } from '@mui/material';

export const TaxDocumentsPage: React.FC = () => {
    return (
        <Box>
            <Typography variant="h4" component="h1" gutterBottom>
                Documentos Tributarios
            </Typography>
            <Typography variant="body1">
                Gestión de documentos tributarios y exportación F29 - En desarrollo
            </Typography>
        </Box>
    );
}; 